import { GameId } from '@common'
import Image from 'next/image'

import ProductInfoImg from '@/assets/images/storefronts/clashofclans/product-page-info.png'

import { StoreTypography } from '../typography/StoreTypography'

import styles from './info.module.scss'

//TODO: translations

const gameNames: Record<GameId, string> = {
  clashofclans: 'Clash of Clans',
  clashroyale: 'Clash Royale',
  brawlstars: 'Brawl Stars',
  hayday: 'Hay Day',
}

export const ProductInfo = ({ game }: { game: GameId }) => {
  const gameName = ` ${gameNames[game]}`
  const body1 = `Every purchase you make in the${gameName} store earns you points towards your next Store Bonus.`
  const body2 = `Want extra points? Complete the challenges listed in the Bonus Track. Each season there is a new track of bonuses to earn.`

  return (
    <div className={styles.info}>
      <div className={styles.infoContent}>
        <StoreTypography tag="h5" style="plain" textSize="body" overrideFont="supercellTextMedium">
          Earn Bonuses and Points
        </StoreTypography>
        <div className={styles.infoImage}>
          <Image src={ProductInfoImg} alt="Products info" quality={100} fill sizes="150px" />
        </div>
        <p>{body1}</p>

        <p>{body2}</p>
      </div>
    </div>
  )
}

ProductInfo.displayName = 'ProductInfo'
